module.exports = __webpack_public_path__ + "static/img/tiger-4-arms.9ed7591.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/amenities/benches/tiger-4-arms.jpg
// module id = 571
// module chunks = 0